export const COLORS = {
    // primary
    primary900: '#016562',
    primary800: '#017A79',
    primary700: '#018E8D',
    primary600: '#01A2A1',
    primary500: '#01B2B0',
    primary400: '#01CDCB',
    primary300: '#10E1E5',
    primary200: '#4AEDEC',
    primary100: '#90F4F3',
    primary50: '#D1FAFA',

    // error
    errorDark: '#C62828',
    errorLight: '#E53935',
    errorLightest: '#FFDCDC',

    // warning
    warningDark: '#FFA000',
    warningLight: '#FFC107',

    // success
    successDark: '#00C853',
    successLight: '#00E676',
    successMedium: '#ADF0C7',

    // black
    blackHighEmphasis: '#212121',
    blackMediumEmphasis: '#666666',
    blackDisabled: '#9E9E9E',
    blackInactive: '#757575',

    // white
    whiteHighEmphasis: '#FFFFFF',
    whiteMediumEmphasis: 'rgba(255, 255, 255, 0.70)',
    whiteDisabled: 'rgba(255, 255, 255, 0.50)',
    whiteInactive: 'rgba(255, 255, 255, 0.54)',

    // background
    backgroundDark: '#E8E8E8',
    backgroundLight: '#FAFAFA',

    // background
    grayDark: '#9E9E9E',
    grayDivider: '#E5E5E5',
    grayLight: '#F5F5F5',
    grayInactive: '#D7D5D5',
}
